module.exports = __webpack_public_path__ + "img/return.32511ca4.jpg";